<div class="toast {{ toast_classes }} {{ position }} {{ animation }} hide p-2" role="alert" aria-live="assertive" aria-atomic="true" (click)="handleClick()" [style.cursor]="url || onClick ? 'pointer' : 'default'">
    <div class="toast-header border-0">
        <i [class]="icon + ' ' + color_class + ' me-2'"></i>

        <span class="me-auto font-weight-bold">{{ title }}</span>
        <small class="text-body">{{ time }}</small>
        
        <i class="fas fa-times text-md ms-3 cursor-pointer" data-bs-dismiss="toast" (click)="$event.stopPropagation()"></i>
    </div>

    <hr class="horizontal dark m-0">

    <div class="toast-body">
        {{ message }}
    </div>
</div>